var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTreasureChest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 106.879,
    y2: 593.738
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8231,
    stopColor: "#0590fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182fc"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0182fc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 316.548,
    y2: 436.579
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6a96c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca6e59"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(.975 -.224 .224 .975 -53.217 62.26)",
    gradientUnits: "userSpaceOnUse",
    x1: 220.969,
    x2: 256.595,
    xlinkHref: "#lg2",
    y1: 139.879,
    y2: 302.602
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca6e59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883f2e"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(.975 -.224 .224 .975 -53.217 62.26)",
    gradientUnits: "userSpaceOnUse",
    x1: 257.009,
    x2: 306.459,
    xlinkHref: "#lg3",
    y1: 195.452,
    y2: 37.212
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(.975 -.224 .224 .975 -53.217 62.26)",
    gradientUnits: "userSpaceOnUse",
    x1: 245.715,
    x2: 289.261,
    xlinkHref: "#lg3",
    y1: 231.595,
    y2: 92.248
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(.975 -.224 .224 .975 -53.217 62.26)",
    gradientUnits: "userSpaceOnUse",
    x1: 224.109,
    x2: 257.101,
    xlinkHref: "#lg4",
    y1: 154.579,
    y2: 305.274
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(.975 -.224 .224 .975 -53.217 62.26)",
    gradientUnits: "userSpaceOnUse",
    x1: 221.399,
    x2: 267.805,
    xlinkHref: "#lg2",
    y1: 235.055,
    y2: 447.019
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(.975 -.224 .224 .975 -53.217 62.26)",
    gradientUnits: "userSpaceOnUse",
    x1: 212.084,
    x2: 455.928,
    xlinkHref: "#lg3",
    y1: 394.535,
    y2: 198.484
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(.975 -.224 .224 .975 -53.217 62.26)",
    gradientUnits: "userSpaceOnUse",
    x1: 198.458,
    x2: 402.119,
    xlinkHref: "#lg3",
    y1: 435.428,
    y2: 230.522
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca6e59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1958,
    stopColor: "#b5604b",
    stopOpacity: 0.196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4986,
    stopColor: "#9d4e3b",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7753,
    stopColor: "#8d4331",
    stopOpacity: 0.775
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#883f2e"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(.975 -.224 .224 .975 -53.217 62.26)",
    gradientUnits: "userSpaceOnUse",
    x1: 117.145,
    x2: 55.094,
    xlinkHref: "#lg5",
    y1: 334.643,
    y2: 334.643
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(.975 -.224 .224 .975 -53.217 62.26)",
    gradientUnits: "userSpaceOnUse",
    x1: 220.175,
    x2: 269.186,
    xlinkHref: "#lg4",
    y1: 229.467,
    y2: 453.324
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(-.975 .224 -.224 -.975 -1491.063 1059.723)",
    gradientUnits: "userSpaceOnUse",
    x1: -1891.688,
    x2: -1843.548,
    xlinkHref: "#lg4",
    y1: 206.265,
    y2: 426.147
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(.975 -.224 .224 .975 -53.217 62.26)",
    gradientUnits: "userSpaceOnUse",
    x1: 243.202,
    x2: 243.202,
    y1: 401.987,
    y2: 435.513
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7701"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(.975 -.224 .224 .975 -53.217 62.26)",
    gradientUnits: "userSpaceOnUse",
    x1: 319.402,
    x2: 137.757,
    xlinkHref: "#lg5",
    y1: 315.399,
    y2: 196.16
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(.975 -.224 .224 .975 -53.217 62.26)",
    gradientUnits: "userSpaceOnUse",
    x1: 237.657,
    x2: 252.518,
    xlinkHref: "#lg6",
    y1: 207.844,
    y2: 275.721
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(.975 -.224 .224 .975 -53.217 62.26)",
    gradientUnits: "userSpaceOnUse",
    x1: 265.243,
    x2: 223.759,
    xlinkHref: "#lg6",
    y1: 260.239,
    y2: 218.755
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(.975 -.224 .224 .975 -53.217 62.26)",
    gradientUnits: "userSpaceOnUse",
    x1: 238.61,
    x2: 251.566,
    y1: 235.817,
    y2: 248.773
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.834,
    x2: 258.443,
    y1: 375.315,
    y2: 485.858
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0028,
    stopColor: "#ffdcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa9b1"
  }))), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.556,
    x2: 305.672,
    xlinkHref: "#lg1",
    y1: 255.759,
    y2: -312.878
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.227,
    x2: 297.118,
    xlinkHref: "#lg1",
    y1: 299.148,
    y2: -172.295
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 427.542,
    y2: 531.049
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 355.579,
    x2: 394.979,
    xlinkHref: "#lg6",
    y1: 128.836,
    y2: 168.236
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 399.355,
    x2: 416.867,
    xlinkHref: "#lg6",
    y1: 193.209,
    y2: 210.721
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.196,
    x2: 46.708,
    xlinkHref: "#lg6",
    y1: 304.369,
    y2: 321.881
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.955,
    x2: 406.467,
    xlinkHref: "#lg6",
    y1: 86.025,
    y2: 103.537
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 292.563,
    x2: 310.075,
    xlinkHref: "#lg6",
    y1: 69.72,
    y2: 87.232
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m462.111 38.963c-9.591 5.962-21.716 6.041-31.384.204l-16.493-9.958c-19.567-11.814-44.076-11.784-63.614.079l-.846.513c-19.373 11.762-43.731 11.564-62.91-.512-19.601-11.835-44.146-11.835-63.747.001-19.601 11.836-44.146 11.836-63.747.001l-.002-.001c-20.072-11.621-44.878-11.392-64.733.596l-14.688 8.868c-9.963 6.016-22.44 6.016-32.403 0-20.888-12.615-47.544 2.427-47.544 26.83v403.647c0 11.267 9.133 20.4 20.4 20.4h469.2c11.267 0 20.4-9.133 20.4-20.4v-403.65c0-24.583-27.011-39.597-47.889-26.618z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 291.049v178.182c0 11.267 9.133 20.4 20.4 20.4h469.2c11.267 0 20.4-9.133 20.4-20.4v-178.182z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m289.259 124.222-149.638 34.314c-46.455 10.653-74.699 60.346-63.085 110.994l6.641 28.96c2.347 10.236 11.862 16.789 21.251 14.636l283.866-65.095c9.389-2.153 15.097-12.197 12.75-22.433l-6.641-28.96c-11.614-50.647-58.689-83.069-105.144-72.416z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.537 269.53 6.641 28.96c2.347 10.236 11.862 16.789 21.251 14.636l283.866-65.095c9.389-2.153 15.097-12.197 12.75-22.433l-6.641-28.96c-6.183-26.961-22.414-48.756-43.251-61.639l-262.544 60.205c-13.141 20.675-18.255 47.365-12.072 74.326z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.537 269.53 6.641 28.96c2.347 10.236 11.862 16.789 21.251 14.636l283.866-65.095c9.389-2.153 15.097-12.197 12.75-22.433l-6.641-28.96c-3.07-13.388-8.62-25.499-15.979-35.881l-303.14 69.515c-2.1 12.55-1.818 25.87 1.252 39.258z",
    fill: "url(#SVGID_5_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m365.639 152.017 5.514 24.048c1.626 7.091-2.804 14.157-9.895 15.783l-251.752 57.731c-7.091 1.626-14.157-2.804-15.783-9.895l-7.053-30.756c-1.459-6.363-10.048-7.496-13.1-1.725-10.172 19.24-13.756 42.08-8.509 64.958l6.641 28.96c2.347 10.236 12.548 16.632 22.785 14.284l303.744-69.653c10.236-2.347 16.632-12.548 14.284-22.785l-6.641-28.96c-4.486-19.563-14.771-36.287-28.624-48.78-5.123-4.622-13.153.063-11.611 6.79z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m385.262 209.969-294.689 67.577c-9.85 2.259-16.049 11.879-13.846 21.487l33.445 145.848c2.203 9.608 11.975 15.566 21.825 13.307l294.689-67.577c9.85-2.259 16.049-11.879 13.846-21.487l-33.445-145.848c-2.203-9.608-11.975-15.566-21.825-13.307z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400.851 277.949-294.689 67.577c-9.85 2.259-16.722 8.948-15.347 14.94l20.859 90.962c1.374 5.992 10.473 9.019 20.324 6.76l294.689-67.577c9.85-2.259 16.722-8.948 15.347-14.94l-20.859-90.962c-1.375-5.992-10.474-9.019-20.324-6.76z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410.191 318.681-294.689 67.577c-9.85 2.259-17.124 7.191-16.247 11.017l13.318 58.075c.877 3.826 9.574 5.096 19.424 2.837l294.689-67.577c9.85-2.259 17.124-7.192 16.247-11.017l-13.318-58.075c-.877-3.826-9.573-5.096-19.424-2.837z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.82 264.647-56.248 12.898c-9.85 2.259-16.049 11.879-13.846 21.487l33.445 145.848c2.203 9.608 11.975 15.566 21.825 13.307l56.248-12.898z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.435 203.026-303.744 69.653c-10.236 2.347-16.631 12.548-14.284 22.785l35.632 155.382c2.347 10.236 12.548 16.632 22.785 14.284l303.744-69.653c10.236-2.347 16.632-12.548 14.284-22.785l-35.632-155.382c-2.347-10.236-12.548-16.631-22.785-14.284zm24.382 155.029c1.785 7.784-3.078 15.542-10.863 17.327l-254.332 58.322c-7.784 1.785-15.542-3.078-17.327-10.863l-25.853-112.741c-1.785-7.784 3.078-15.542 10.863-17.327l254.332-58.322c7.784-1.785 15.542 3.078 17.327 10.863z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.984 447.398 274.811-63.018c9.003-2.065 14.684-10.793 12.688-19.496l-30.294-132.105c-1.996-8.703-10.912-14.084-19.915-12.02l-274.811 63.018c-9.003 2.065-14.684 10.793-12.688 19.496l30.294 132.105c1.996 8.703 10.912 14.084 19.915 12.02zm-35.542-137.297c-1.785-7.784 3.078-15.542 10.863-17.327l254.332-58.322c7.784-1.785 15.542 3.078 17.327 10.863l25.853 112.741c1.785 7.784-3.078 15.542-10.863 17.327l-254.332 58.322c-7.784 1.785-15.542-3.078-17.327-10.863z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410.646 348.589 2.171 9.467c1.785 7.784-3.078 15.542-10.863 17.327l-254.332 58.322c-7.784 1.785-15.542-3.078-17.327-10.863l-2.171-9.467-29.145 6.684 7.06 30.788c2.347 10.236 12.548 16.632 22.785 14.284l303.744-69.653c10.236-2.347 16.632-12.548 14.284-22.785l-7.06-30.788z",
    fill: "url(#SVGID_13_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m446.852 372.693-14.1-61.489-166.242-104.221c-3.055-3.056-7.558-4.53-12.081-3.493l-46.466 10.655c-6.987 1.602-11.352 8.565-9.749 15.551l6.236 27.196c2.256 9.837 8.725 17.61 17.064 21.861l192.844 120.898 18.209-4.176c10.237-2.345 16.632-12.546 14.285-22.782z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.109 278.732-7.926 1.818c-17.629 4.043-35.198-6.971-39.24-24.601l-6.237-27.196c-1.602-6.987 2.763-13.949 9.749-15.551l46.466-10.655c6.987-1.602 13.949 2.763 15.551 9.749l6.236 27.196c4.044 17.629-6.97 35.197-24.599 39.24z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.701 267.771 5.173-1.186c11.506-2.639 18.695-14.105 16.057-25.612l-4.071-17.751c-1.046-4.56-5.59-7.409-10.15-6.363l-30.328 6.955c-4.56 1.046-7.409 5.59-6.363 10.15l4.071 17.751c2.638 11.506 14.105 18.695 25.611 16.056z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249.075 234.847c-1.588-6.926-8.491-11.253-15.417-9.665s-11.253 8.491-9.665 15.417c1.166 5.085 5.2 8.758 10.001 9.729l1.841 8.028c.653 2.849 3.493 4.63 6.343 3.976 2.849-.653 4.63-3.493 3.976-6.342l-1.841-8.028c3.898-2.966 5.928-8.03 4.762-13.115z",
    fill: "url(#SVGID_17_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m477.585 415.881c-109.919-56.442-335.251-56.442-445.17 0-19.963 10.25-32.415 30.909-32.415 53.35 0 11.267 9.133 20.4 20.4 20.4h469.2c11.267 0 20.4-9.133 20.4-20.4 0-22.441-12.452-43.1-32.415-53.35z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.889 76.611c9.591 5.962 21.716 6.041 31.384.204l16.493-9.958c19.567-11.814 44.076-11.784 63.614.079l.846.513c19.373 11.762 43.731 11.564 62.91-.512 19.601-11.835 44.146-11.835 63.747.001 19.601 11.836 44.146 11.836 63.747.001l.003-.001c20.072-11.621 44.878-11.392 64.733.596l14.688 8.868c9.963 6.016 22.44 6.016 32.403 0 20.887-12.615 47.543 2.427 47.543 26.83v365.999c0 11.267-9.133 20.4-20.4 20.4h-469.2c-11.267 0-20.4-9.133-20.4-20.4v-366.002c0-24.583 27.011-39.597 47.889-26.618z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.889 155.611c9.591 5.962 21.716 6.041 31.384.204l16.493-9.958c19.567-11.814 44.076-11.784 63.614.079l.846.513c19.373 11.762 43.731 11.564 62.91-.512 19.601-11.835 44.146-11.835 63.747.001 19.601 11.836 44.146 11.836 63.747.001l.003-.001c20.072-11.621 44.878-11.392 64.733.596l14.688 8.868c9.963 6.016 22.44 6.016 32.403 0 20.89-12.614 47.545 2.429 47.545 26.831v286.999c0 11.267-9.133 20.4-20.4 20.4h-469.202c-11.267 0-20.4-9.133-20.4-20.4v-287.002c0-24.584 27.011-39.598 47.889-26.619z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 397.458v71.773c0 11.267 9.133 20.4 20.4 20.4h469.2c11.267 0 20.4-9.133 20.4-20.4v-71.773z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 367.134,
    cy: 140.391,
    fill: "url(#SVGID_22_)",
    r: 28.125
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408.521,
    cy: 202.376,
    fill: "url(#SVGID_23_)",
    r: 16.305
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.362,
    cy: 313.535,
    fill: "url(#SVGID_24_)",
    r: 16.305
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.122,
    cy: 95.191,
    fill: "url(#SVGID_25_)",
    r: 16.305
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.729,
    cy: 78.886,
    fill: "url(#SVGID_26_)",
    r: 16.305
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTreasureChest);
export default __webpack_public_path__ + "static/media/icon-treasure-chest.3f23f7c02e6c900ddd6ae3069652be30.svg";
export { ForwardRef as ReactComponent };